import React from 'react';
import styled from 'styled-components';
import { palette, lightTheme } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import loadable from '@loadable/component';

import Paper from '@material-ui/core/Paper';

const List = loadable(() => import('@material-ui/core/List'));
const ListItem = loadable(() => import('@material-ui/core/ListItem'));
const ListItemText = loadable(() => import('@material-ui/core/ListItemText'));
const Typography = loadable(() => import('@material-ui/core/Typography'));

const DropdownPaper = styled(Paper)`
  padding: 16px;
  margin: 0 0 30px;
  position: absolute;
  min-width: 100%;
  z-index: 1000;
  border-radius: 0px 0px 5px 5px;
`;

const AutoList = styled(List)`
  margin: 0 -16px;
  padding-bottom: 0;
`;

const AutoListItem = styled(ListItem)`
  cursor: pointer;
  &[aria-selected='true'] {
    background: ${palette.grey[50]};
  }
`;

const AutoListItemText = styled(ListItemText)`
  em {
    background: rgba(255, 255, 25, 0.25);
  }
`;

function getRaw(result, value) {
  if (!result[value] || !result[value].raw) return;
  return result[value].raw;
}

function getSnippet(result, value) {
  if (!result[value] || !result[value].snippet) return;
  return result[value].snippet;
}

function CustomAutocomplete({
  autocompleteResults,
  autocompletedResults,
  getItemProps,
  getMenuProps
}) {
  let index = 0;
  return (
    <MuiThemeProvider theme={lightTheme}>
      <DropdownPaper {...getMenuProps()}>
        <div>
          {!!autocompleteResults &&
            !!autocompletedResults &&
            autocompletedResults.length > 0 &&
            autocompleteResults.sectionTitle && (
              <Typography variant="overline">
                {autocompleteResults.sectionTitle}
              </Typography>
            )}
          {!!autocompleteResults &&
            !!autocompletedResults &&
            autocompletedResults.length > 0 && (
              <AutoList>
                {autocompletedResults.map(result => {
                  index++;
                  const titleSnippet = getSnippet(
                    result,
                    autocompleteResults.titleField || 'title'
                  );
                  const titleRaw = getRaw(
                    result,
                    autocompleteResults.titleField || 'title'
                  );
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <AutoListItem
                      {...getItemProps({
                        key: result.id.raw,
                        index: index - 1,
                        item: result
                      })}
                    >
                      <AutoListItemText>
                        {titleSnippet ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: titleSnippet
                            }}
                          />
                        ) : (
                          <>{titleRaw}</>
                        )}
                      </AutoListItemText>
                    </AutoListItem>
                  );
                })}
              </AutoList>
            )}
        </div>
      </DropdownPaper>
    </MuiThemeProvider>
  );
}

export default CustomAutocomplete;
